import { gql } from '@apollo/client';

export const GET_PANEL_LLEGADAS_SALIDAS = gql`
  query PanelLlegadasSalidas($fecha: String) {
    panelLlegadasSalidas(fecha: $fecha) {
      fecha
      ocupacion_actual
      capacidad_total
      llegadas {
        id
        tipo
        reserva_id
        codigo
        huesped_nombre
        huesped_documento
        pax
        habitacion_numero
        habitacion_tipo
        fecha_entrada
        fecha_salida
        noches
        estado
      }
      salidas {
        id
        codigo
        huesped_nombre
        pax
        habitacion_numero
        habitacion_tipo
        fecha_entrada
        fecha_salida_prevista
        noches
        estado
      }
      in_house {
        id
        codigo
        huesped_nombre
        pax
        habitacion_numero
        habitacion_tipo
        fecha_entrada
        fecha_salida_prevista
        noches_totales
        noches_restantes
        dias_overstay
      }
    }
  }
`;
